import React from "react";
import DayPicker from "react-day-picker";

/**
 * Wrapper matching Flights-UI DayPickerWrapper.
 * Renders DayPicker inside datePickerWrapper > dayPickerFlightWrap return-cal.
 */
export default function DatePickerWrapper(dayPickerProps) {
  return (
    <div className="datePickerWrapper">
      <div className="dayPickerFlightWrap return-cal">
        <DayPicker {...dayPickerProps} />
      </div>
    </div>
  );
}
